module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-row', {
    attrs: {
      "type": "flex",
      "justify": "center"
    }
  }, [_c('el-col', {
    attrs: {
      "xs": 24,
      "sm": 12,
      "md": 10,
      "lg": 8
    }
  }, [_c('el-form', {
    attrs: {
      "label-position": "top",
      "label-width": "100px"
    }
  }, [_c('h1', [_vm._v("Login")]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Email:"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "Your email address",
      "type": "email",
      "disabled": _vm.app.isLoading
    },
    on: {
      "input": function($event) {
        _vm.$v.credentials.email.$touch()
      }
    },
    model: {
      value: (_vm.credentials.email),
      callback: function($$v) {
        _vm.credentials.email = (typeof $$v === 'string' ? $$v.trim() : $$v)
      },
      expression: "credentials.email"
    }
  }), _vm._v(" "), (_vm.$v.credentials.email.$error) ? _c('span', [(!_vm.$v.credentials.email.required) ? _c('span', {
    staticClass: "el-form-item__error"
  }, [_vm._v("Field is required.")]) : _vm._e(), _vm._v(" "), (!_vm.$v.credentials.email.email) ? _c('span', {
    staticClass: "el-form-item__error"
  }, [_vm._v("Must be a valid email.")]) : _vm._e()]) : _vm._e()], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Password:"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "Your password",
      "type": "password",
      "disabled": _vm.app.isLoading
    },
    on: {
      "input": function($event) {
        _vm.$v.credentials.password.$touch()
      }
    },
    model: {
      value: (_vm.credentials.password),
      callback: function($$v) {
        _vm.credentials.password = (typeof $$v === 'string' ? $$v.trim() : $$v)
      },
      expression: "credentials.password"
    }
  }), _vm._v(" "), (_vm.$v.credentials.password.$error) ? _c('span', [(!_vm.$v.credentials.password.required) ? _c('span', {
    staticClass: "el-form-item__error"
  }, [_vm._v("Field is required.")]) : _vm._e()]) : _vm._e()], 1), _vm._v(" "), _c('hr'), _vm._v(" "), _c('p', [_c('el-button', {
    attrs: {
      "type": "primary",
      "disabled": _vm.$v.$invalid,
      "loading": _vm.app.isLoading
    },
    on: {
      "click": function($event) {
        _vm.login()
      }
    }
  }, [_vm._v("Login")]), _vm._v(" "), _c('small', {
    staticClass: "links"
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'Register'
      }
    }
  }, [_vm._v("Register")]), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": {
        name: 'Reminder'
      }
    }
  }, [_vm._v("Forgot your password?")])], 1)], 1)], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4b5c2aa0","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/auth/Login.vue
// module id = 631
// module chunks = 1